/** When and by whom an item in the trash was deleted: its rows, and what a cleanup would take. */
import type { TrashRow } from "../../api/types.gen.ts";
import { SLOT, t } from "../../i18n/index.ts";
import { formatInstant, formatRelative } from "../../lib/format.ts";
import { Person } from "../../ui/Avatar.tsx";
import { Slotted } from "../../ui/misc.tsx";

/** "3 minutes ago by [avatar] Marco" (the exact time on hover). */
export function DeletedBy({ row }: { row: TrashRow }) {
  const when = formatRelative(row.deleted_at);
  return (
    <span class="text-zinc-500" title={formatInstant(row.deleted_at)}>
      {row.deleted_by_name ? (
        <Slotted text={t("trash.deletedBy", { when, who: SLOT })}>
          <Person name={row.deleted_by_name} id={row.deleted_by} size={16} />
        </Slotted>
      ) : (
        t("trash.deletedBySystem", { when })
      )}
    </span>
  );
}
